/**
 * Helper function to get cookies module without creating circular dependencies
 *
 * This breaks the following circular dependency chain:
 * loggerHelper.js → datadog.js → appConsts.js → storageHelper.js → cookies.js → loggerHelper.js
 *
 * This function uses require() at function scope rather than import at module scope.
 * By dynamically importing the module only when needed, we allow the module system
 * to resolve other dependencies first, breaking the circular reference.
 *
 * @returns {Object} The cookies module default export
 */
export function getCookies() {
  return require('utils/storage/cookies').default;
}
